import React from 'react';

interface DataSource {
  type: 'cedar' | 'garmin' | 'strava' | 'apple_health' | 'health_connect' | 'android_health' | 'google_health';
  deviceModel?: string;
  deviceManufacturer?: string;
}

interface DataSourceBadgesProps {
  sources: DataSource[];
  size?: 'small' | 'medium';
  showLabels?: boolean;
}

export const DataSourceBadges: React.FC<DataSourceBadgesProps> = ({
  sources,
  size = 'small',
  showLabels = false,
}) => {
  const iconSize = size === 'small' ? 'h-3.5' : 'h-4'; // 14px or 16px

  const renderSourceIcon = (source: DataSource) => {
    switch (source.type) {
      case 'cedar':
        return (
          <div key="cedar" className="flex items-center gap-1">
            <img
              src="/favicon.png"
              alt="Coach Cedar"
              className={`${iconSize} rounded-sm`}
            />
          </div>
        );

      case 'garmin':
        return (
          <div key="garmin" className="flex items-center gap-1.5">
            <img
              src="/garmin-assets/Garmin Tag-black-high-res.png"
              alt="Garmin"
              className={iconSize}
            />
            {source.deviceModel && (
              <span className="text-xs font-medium text-gray-700">
                {source.deviceModel}
              </span>
            )}
          </div>
        );

      case 'strava':
        return (
          <div key="strava" className="flex items-center gap-1">
            <img
              src="/strava-assets/api_logo_pwrdBy_strava_horiz_black.png"
              alt="Strava"
              className={`${iconSize} opacity-80`}
              style={{ height: size === 'small' ? '14px' : '16px', width: 'auto' }}
            />
          </div>
        );

      case 'apple_health':
        return (
          <div key="apple_health" className="flex items-center gap-1">
            <img
              src="/apple_health_icon.png"
              alt="Apple Health"
              style={{ width: size === 'small' ? 16 : 18, height: size === 'small' ? 16 : 18, borderRadius: size === 'small' ? 3.5 : 4 }}
            />
            <span className="text-xs text-gray-600">Health</span>
          </div>
        );

      case 'health_connect':
      case 'android_health':
        return (
          <div key="health_connect" className="flex items-center gap-1">
            <img
              src="/health-connect-logo.png"
              alt="Health Connect"
              style={{ width: size === 'small' ? 16 : 18, height: size === 'small' ? 16 : 18 }}
            />
            <span className="text-xs text-gray-600">Health Connect</span>
            {source.deviceModel && (
              <span className="text-xs font-medium text-gray-700">
                · {source.deviceModel}
              </span>
            )}
          </div>
        );

      default:
        return null;
    }
  };

  if (sources.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-1.5">
      {showLabels && (
        <span className="text-xs text-gray-500 mb-0.5">Data sources:</span>
      )}
      {sources.map(renderSourceIcon)}
    </div>
  );
};

export default DataSourceBadges;





